// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Common Client V2 imports
const CardGrid = require('client-v2/common/components/card-grid')
const { CheckExperiment } = require('client-v2/common/containers/rollouts')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('DiscoverSection')

class DiscoverSection extends React.PureComponent {

  renderGrid() {
    return (
      tag(CardGrid, Object.assign({}, this.props, {
        className: bem.element('grid')
      }))
    )
  }

  renderHeader() {
    if (!this.props.isHeaderVisible) {
      return null
    }
    return tag(CheckExperiment, {
      experimentKey: '*logged_out_top_cta',
      renderWithModifier: modifier => {
        if (modifier === 'c') {
          return this.renderHeaderVersionC()
        }
        if (modifier === 'b') {
          return this.renderHeaderVersionB()
        }
        return this.renderHeaderVersionA()
      }
    })
  }

  renderHeaderVersionA() {
    return tag('div', {
      className: bem.element('header', 'a')
    },
      tag('div', {
        className: bem.element('heading')
      },
        `Discover your next favorite thing.`
      ),
      tag('div', {
        className: bem.element('subheading')
      },
        `Go deeper into new topics and explore any interest.\n`,
        `Then share with others.`
      )
    )
  }

  renderHeaderVersionB() {
    return tag('div', {
      className: bem.element('header', 'b')
    },
      tag('div', {
        className: bem.element('heading')
      },
        `Explore Top Picks on Mix`
      ),
      tag('div', {
        className: bem.element('subheading')
      },
        `Mix shows you content matched to your interests,\n`,
        `recommended by friends and community experts.`
      )
    )
  }

  renderHeaderVersionC() {
    return tag('div', {
      className: bem.element('header', 'c')
    },
      tag('div', {
        className: bem.element('heading')
      },
        `Explore Top Picks on Mix`
      )
    )
  }

  renderMoreButton() {
    if (!this.props.isMoreAvailable) {
      return null
    }
    return (
      tag('button', {
        className: bem.element('button'),
        onClick: this.props.onMoreClick
      },
        `Load more`
      )
    )
  }

  render() {
    return (
      tag('div', {
        className: bem.block()
      },
        this.renderHeader(),
        this.renderGrid(),
        this.renderMoreButton()
      )
    )
  }
}

DiscoverSection.propTypes = {
  // Flags
  isHeaderVisible: PropTypes.bool,
  isMoreAvailable: PropTypes.bool,
  // Callbacks
  onMoreClick: PropTypes.func
}

module.exports = DiscoverSection
